export const CONSTANTS = {
  COOKIE_NAME_USER: 'zjs_user_id',
  COOKIE_NAME_LOGGEDIN: 'isLoggedInUpsellBannerClosed',
  COOKIE_EXP_LOGGEDIN: 30,
  COOKIE_NAME_LOGGEDOUT: 'isHomePageUpsellBannerClosed',
  COOKIE_EXP_LOGGEDOUT: 1,
  COOKIE_VALUE: 'true',
  HEADER_TEXT_LOGGEDIN: 'Instant notifications & more,',
  BODY_TEXT_LOGGEDIN: 'only in the app.',
  HEADER_TEXT_LOGGEDOUT: 'Get instant updates',
  BODY_TEXT_LOGGEDOUT: 'on the Zillow Rental Manager App',
  HREF_IOS_LOGGEDIN: 'https://app.us.adjust.com/mm8tgcy?campaign=web&adgroup=listingpathBanner&creative=iOS',
  HREF_IOS_LOGGEDOUT: 'https://app.adjust.com/ft7kjlv',
  HREF_ANDROID_LOGGEDIN: 'https://app.us.adjust.com/etwc1wq?campaign=web&adgroup=listingpathBanner&creative=android',
  HREF_ANDROID_LOGGEDOUT: 'https://app.adjust.com/rg8eacg',
  COOKIE_NAME_HOSTAPP: 'hostApp',
  COOKIE_VALUE_IOS: 'ios',
  COOKIE_VALUE_ANDROID: 'android',
};
